import React, { Component } from "react";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";
import { Row, Col, Card, CardHeader, Container } from "reactstrap";
import DnsProviderConfigForm from "../DnsProviderConfigForm/DnsProviderConfigForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import { updateDnsProviderConfig } from "../../../actions/actionDnsProvider";
import { handleSaveSuccess, handleSaveError } from '../actions'

const routes = [
    { name: "Home", path: "/userdashboard", isActive: false },
    { name: "Provider", path: "/provider", isActive: false },
    { name: "UpdateDnsProvider", path: "/update_dns_provider", isActive: true },
];

class UpdateDnsProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        this.submitApi = this.submitApi.bind(this);
        this.handleSaveSuccess = handleSaveSuccess.bind(this);
        this.handleSaveError = handleSaveError.bind(this);

    }

    componentDidMount(){
        this.props.getDnsProviderConfigs();
    }

    async submitApi(userData) {
        try {
            let userData = this.props.providerValues
            userData.dns_provider_config_id = this.props.match.params.id
            await this.props.updateDnsProviderConfig(userData)
            const provider = await this.handleSaveSuccess()
            this.props.savedProvider(provider)

        } catch (e) {
            this.handleSaveError()
        }
    }

    render() {
        return (
            <div>
                <BreadCrumbCompo routes={routes} />
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className="user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update DNS Provider Config </strong>
                                </CardHeader>
                                <DnsProviderConfigForm
                                    onSubmit={this.submitApi}
                                    updateDnsProviderConfig={this.props.updateDnsProviderConfig}
                                    DnsProviderConfigId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateDnsProviderConfig.propTypes = {
    updateDnsProviderConfig: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    dns_provider_configs: state.dns_provider.dns_provider_configs || [],
    saveDnsProviderError: state.dns_provider.saveDnsProviderError,
    saveDnsProviderLoading: state.dns_provider.saveDnsProviderLoading,
    savedDnsProvider: state.dns_provider.savedDnsProvider,
    providerValues: getFormValues('DnsProviderForm')(state),
}),
    dispatch => ({
        updateDnsProviderConfig: (data) => dispatch(updateDnsProviderConfig(data))
    }))(UpdateDnsProviderConfig);